import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ActivityModelNew } from "../models/newChanges/activityModelNew";

@Injectable()
export class DuplicateCheckService {




  constructor(private readonly translate: TranslateService) {}

  checkDuplicateEntry(inputListAsString, index, questionEntryJson): boolean {
    let flag = false;
    const qusList = Object.keys(questionEntryJson);
    qusList.forEach(key => {
      if (Number(key) !== index) {
        if (questionEntryJson[key] === inputListAsString) {
          flag = true;
        }
      }
    });
    return flag;
  }
  checkDuplicatedropdwnEntry(inputListAsString, index, questionEntryJson) {
    let flag = false;
    const qusList = Object.keys(questionEntryJson);
    qusList.forEach((key) => {
      if (Number(key) !== index && inputListAsString!=="") {
        if (questionEntryJson[key].includes(inputListAsString)) { 
          flag = true;
        }
      }
    });
    return flag;
  }

  checkDuplicateEntryInActivityLevel(activityForm, activity: ActivityModelNew): void {
    const qusList = activityForm.get("questionList").controls;
    qusList.forEach((qus, index) => {
      if (activity.questionList[index].status !== "delete") {
        const errors = { flag: false, msg: "" };
        const inputListAsString = qus.value.inputList.toString();
        activity.duplicateEntryFlag = this.checkDuplicateEntry(
          inputListAsString,
          index,
          activity.questionEntryJson

        );

        if (activity.duplicateEntryFlag) {
          errors.flag = true;
          errors.msg = this.translate.instant("DuplicateEntry");

          activity.errors = errors;
        } else {
          errors.flag = false;
          activity.errors = errors;
        }
      }
    });
  }
}
